<template>
  <footer class="footer-wrapper">
    <div class="footer-inner">
      <div class="links">
        <ul>
          <li><router-link :to="{name: 'MembersRegister'}">保護者登録</router-link></li>
          <li><router-link :to="{name: 'SittersRegister'}">サポーター登録</router-link></li>
          <li><router-link :to="{name: 'FaqComponent'}">よくある質問</router-link></li>
          <li><router-link :to="{name: 'TermsOfService'}">利用規約</router-link></li>
          <li><router-link :to="{name: 'HogoHoushin'}">個人情報保護方針</router-link></li>
          <li><router-link :to="{name: 'CompanyComponent'}">運営会社</router-link></li>
          <li><router-link :to="{name: 'SctlComponent'}">特定商取引法に基づく表示</router-link></li>
        </ul>
      </div>
      <div class="marks">
        <img src="@/assets/image/common/logo.png">
      </div>
      <div class="copyright">Copyright © 2022 Anela Matching All Rights Reserved.</div>
    </div>
  </footer>
</template>

<script>
export default {
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
footer.footer-wrapper {
  width: 100%;
  background-color: #eee;
  background-image: url(../assets/image/footer/bg_logo_white.png);
  background-position: 50% -2em;
  background-size: 160px 112px;
  border-top: 8px solid #f99;
  .footer-inner {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 10px;
    box-sizing: border-box;
    .links {
      flex: 0 0 auto;
      width: 100%;
      max-width: 400px;
      margin: 10px 10px 20px 10px;
      ul {
        margin: 0 0 1em 0;
        li {
          padding: 0 10px;
          border-bottom: 1px solid white;
          a {
            color: inherit;
            display: block;
            font-size: 12px;
          }
        }
      }
    }
    .marks {
      flex: 0 0 auto;
      margin: 0 0 1em 0;
      text-align: center;
      img {
        height: 32px;
        vertical-align: bottom;
      }
    }
    .copyright {
      flex: 0 0 auto;
      text-align: center;
      font-size: 14px;
    }
  }
  @media (min-width: 576px) {
    background-size: 320px 224px;
    .footer-inner {
      flex-direction: row;
      flex-wrap: wrap;
      padding: 20px;
      .links {
        flex-flow: row wrap;
        width: 480px;
        max-width: 100%;
        margin: 0;
        display: flex;
        ul {
          display: flex;
          flex-wrap: wrap;
          width:100%;
          li {
            flex: 0 0 240px;
            margin: 0;
            padding: 0;
            border-bottom: none;
            a {
              display: block;
              flex: 1 0 30%;
            }
          }
        }
      }
      .marks {
        align-self: flex-end;
        flex: 1 1 auto;
      }
      .copyright {
        flex: 0 0 100%;
      }
    }
  }
  @media (min-width: 768px) {
    .footer-inner {
      .links {
        width:720px;
      }
      .marks {
        img {
          height: 56px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue